import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getData, patchData, getRemoteUrl } from './request'
import { addCases } from './utils'
import { getLoginToken } from './store'
import { getCurrentSessionGeneration, sessionInvalidated } from './session'

function initialState() {
    return {
        info: {},
        infoIsLoading: false,
        needsServerUpdate: false,
        requestError: undefined,
        sessionGeneration: 0,
    }
}

function setErrorState(state, { payload }) {
    if (payload && payload.sessionGeneration !== state.sessionGeneration) return
    state.requestError = (payload && payload.error) || undefined
}

function setUserGeneralInfo(state, { payload }) {
    if (payload.sessionGeneration !== state.sessionGeneration) return
    state.info = payload.info
    state.infoIsLoading = false
    state.needsServerUpdate = false
}

function setUserGeneralInfoLoading(state) {
    state.infoIsLoading = true
    state.needsServerUpdate = false
}

function reqUserGeneralInfo() {
    const sessionGeneration = getCurrentSessionGeneration()
    const loginToken = getLoginToken()
    let params = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${loginToken}`
        }
    }

    return getData(getRemoteUrl("users/me"), params)
        .then(info => ({ sessionGeneration, info }))
}

export function sendInfoToServer(info) {
    const loginToken = getLoginToken()
    const payload = {
        first_name: info.first_name,
        second_name: info.second_name,
        email: info.email,
        birthday: info.birthday
    }

    return patchData(getRemoteUrl("users/me"), payload, loginToken)
};

export const asyncReqUserGeneralInfo = createAsyncThunk(
    'asyncReqUserGeneralInfo',
    async (_, { rejectWithValue }) => {
        try {
            return await reqUserGeneralInfo()
        } catch (error) {
            return rejectWithValue({ sessionGeneration: getCurrentSessionGeneration(), error })
        }
    }
)

export const userinfoSlice = createSlice({
    name: 'userinfo',
    initialState: initialState(),

    reducers: {
        setFirstName(state, {payload}) {
            state.info.first_name = payload
            state.needsServerUpdate = true
        },
        setSecondName(state, {payload}) {
            state.info.second_name = payload
            state.needsServerUpdate = true
        },
        setEmail(state, {payload}) {
            state.info.email = payload
            state.needsServerUpdate = true
        },
        setBirthdayDate(state, {payload}) {
            state.info.birthday = payload
            state.needsServerUpdate = true
        },

        submitInfoToServer(state) {
            state.needsServerUpdate = false
        }
    },

    extraReducers: builder => {
        addCases(builder, asyncReqUserGeneralInfo, setUserGeneralInfo, setUserGeneralInfoLoading, setErrorState)
        builder.addCase(sessionInvalidated, (state, action) => ({
            ...initialState(),
            sessionGeneration: action.payload,
        }))
    }
})

export const { setFirstName, setSecondName, setEmail, submitInfoToServer, setBirthdayDate } = userinfoSlice.actions